import ScrollMagic from './ScrollMagic.min.js'

const init = () => {
  var controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({ triggerElement: '#pinned-trigger1', })
    .setClassToggle('#pinned-trigger2', 'fadeInUp')
    .addTo(controller); // assign the scene to the controller
};
init();


// WEBPACK FOOTER //
// ./site/html/assets/js/scrollmagic-effect.js